import React from "react";
import { SearchIcon } from "../icons";
import { Combobox } from "../ui/combobox";
import { FieldLabel } from "./FormSection";

interface ControlledAutocompleteProps<T> {
  /** Shown above the field. Omit when the caller already labels the section. */
  label?: string;
  placeholder?: string;
  value: T | null;
  onChange: (value: T | null) => void;
  inputValue: string;
  onInputChange: (value: string) => void;
  options: T[];
  loading: boolean;
  getOptionLabel: (option: T) => string;
  disabled?: boolean;
  clearable?: boolean;
}

export function ControlledAutocomplete<T>({
  label,
  placeholder,
  value,
  onChange,
  inputValue,
  onInputChange,
  options,
  loading = false,
  getOptionLabel = (option: any) => option?.toString() || "",
  disabled = false,
  clearable = true,
}: ControlledAutocompleteProps<T>) {
  const id = React.useId();
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <FieldLabel htmlFor={id} required>
          {label}
        </FieldLabel>
      )}
      <Combobox<T>
        id={id}
        name="autocomplete-search"
        value={value}
        onChange={onChange}
        inputValue={inputValue}
        onInputChange={onInputChange}
        options={options}
        getOptionLabel={getOptionLabel}
        loading={loading}
        disabled={disabled}
        clearOnEscape={clearable}
        placeholder={placeholder}
        startIcon={<SearchIcon className="ml-0.5 size-4" />}
      />
    </div>
  );
}
